import { ScrollReveal } from '@/components/shared/ScrollReveal'
import { Button } from '@/components/ui/Button'
import { openSourceProjects } from '@/content/portfolio'

export function Projects() {
  const [featuredProject, ...otherProjects] = openSourceProjects

  return (
    <section id="open-source" className="scroll-mt-24 border-t border-vibe-border bg-vibe-black py-16 lg:py-24">
      <div className="mx-auto max-w-6xl px-4 lg:px-8">
        <ScrollReveal>
          <div className="max-w-3xl">
            <div className="section-label mb-2">Open source</div>
            <h2 className="text-3xl lg:text-4xl font-medium tracking-tight text-text-heading">
              Open source you can inspect
            </h2>
            <p className="mt-4 text-base leading-relaxed text-text-secondary">
              PM-Kit is the main open-source product. The remaining repositories cover goal contracts,
              codebase knowledge, and reusable agent skills.
            </p>
          </div>
        </ScrollReveal>

        {featuredProject && (
          <ScrollReveal delay={0.04}>
            <article className="mt-10 grid overflow-hidden rounded-2xl border border-accent-primary/40 bg-card-bg md:grid-cols-2">
              {featuredProject.image && (
                <div className="aspect-video overflow-hidden border-b border-vibe-border bg-vibe-elevated md:aspect-auto md:border-b-0 md:border-r">
                  <img
                    src={featuredProject.image}
                    alt="PM-Kit public GitHub repository"
                    loading="lazy"
                    className="h-full w-full object-cover"
                  />
                </div>
              )}
              <div className="flex flex-col justify-center p-6 lg:p-8">
                <div className="section-label text-accent-primary">Featured open source</div>
                <h3 className="mt-3 text-2xl font-medium tracking-tight text-text-heading">{featuredProject.name}</h3>
                {featuredProject.traction && (
                  <p className="mt-2 font-mono text-xs uppercase tracking-widest text-accent-primary">{featuredProject.traction}</p>
                )}
                <p className="mt-5 text-[15px] leading-relaxed text-text-primary/80">{featuredProject.description}</p>
                <div className="mt-6">
                  <Button variant="primary" href={featuredProject.href} className="text-xs">View source</Button>
                </div>
              </div>
            </article>
          </ScrollReveal>
        )}

        <div className="mt-5 grid grid-cols-1 gap-4 md:grid-cols-3">
          {otherProjects.map((project, index) => (
            <ScrollReveal key={project.name} delay={index * 0.04}>
              <article className="flex h-full flex-col rounded-2xl border border-vibe-border bg-card-bg p-5 lg:p-6">
                <h3 className="text-xl font-medium tracking-tight text-text-heading">{project.name}</h3>
                <p className="mt-4 flex-1 text-[15px] leading-relaxed text-text-secondary">{project.description}</p>
                <div className="mt-6 flex flex-wrap gap-3">
                  <Button variant="primary" href={project.href} className="text-xs">GitHub</Button>
                </div>
              </article>
            </ScrollReveal>
          ))}
        </div>
      </div>
    </section>
  )
}
